import { useState } from "react";
import { ImagePlus } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "@/lib/api";

export const Field = ({ label, ...props }) => (
  <div>
    <label className="text-[10px] uppercase tracking-[0.25em] text-zinc-500 block mb-2">{label}</label>
    <input
      {...props}
      className="w-full bg-zinc-100 border border-zinc-200 text-zinc-900 text-sm px-4 py-3 focus:outline-none focus:border-gold/60 transition-colors duration-300"
    />
  </div>
);

export const ImageField = ({ value, onChange, testid, label = "Photo" }) => {
  const [uploading, setUploading] = useState(false);

  const pick = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const fd = new FormData();
    fd.append("file", file);
    setUploading(true);
    try {
      const { data } = await api.post("/admin/upload", fd, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      onChange(`${process.env.REACT_APP_BACKEND_URL}${data.url}`);
      toast.success("Image uploaded");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setUploading(false);
      e.target.value = "";
    }
  };

  return (
    <div>
      <label className="text-[10px] uppercase tracking-[0.25em] text-zinc-500 block mb-2">{label}</label>
      <div className="flex items-start gap-4">
        <div className="w-20 h-24 bg-zinc-100 border border-zinc-200 flex items-center justify-center overflow-hidden shrink-0">
          {value ? (
            <img src={value} alt="Preview" className="w-full h-full object-cover" data-testid={`${testid}-preview`} />
          ) : (
            <ImagePlus size={18} className="text-zinc-300" />
          )}
        </div>
        <div className="flex-1 space-y-3">
          <label
            data-testid={`${testid}-upload-btn`}
            className={`inline-flex items-center gap-2 cursor-pointer border border-gold/40 text-gold text-[10px] uppercase tracking-[0.25em] px-5 py-3 hover:bg-gold hover:text-white transition-colors duration-300 ${uploading ? "opacity-50 pointer-events-none" : ""}`}
          >
            <ImagePlus size={13} />
            {uploading ? "Uploading…" : "Upload Image"}
            <input type="file" accept="image/*" onChange={pick} className="hidden" data-testid={`${testid}-file-input`} />
          </label>
          <input
            value={value}
            onChange={(e) => onChange(e.target.value)}
            placeholder="…or paste an image URL"
            data-testid={testid}
            className="w-full bg-zinc-100 border border-zinc-200 text-zinc-900 text-xs px-4 py-2.5 focus:outline-none focus:border-gold/60 transition-colors duration-300"
          />
        </div>
      </div>
    </div>
  );
};
